/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S6_NoteInputs */

const tr_cerez_s6_note = /** @type {(inputs: Cerez_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zorunlu çerezleri engellemeniz halinde Platform'un bazı özellikleri çalışmayabilir.`)
};

const en_cerez_s6_note = /** @type {(inputs: Cerez_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you block the necessary cookies, some features of the Platform may not work.`)
};

const de_cerez_s6_note = /** @type {(inputs: Cerez_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie die erforderlichen Cookies blockieren, funktionieren einige Funktionen der Plattform möglicherweise nicht.`)
};

const ru_cerez_s6_note = /** @type {(inputs: Cerez_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если вы заблокируете обязательные файлы cookie, некоторые функции Платформы могут не работать.`)
};

/**
* | output |
* | --- |
* | "If you block the necessary cookies, some features of the Platform may not work." |
*
* @param {Cerez_S6_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s6_note = /** @type {((inputs?: Cerez_S6_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S6_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s6_note(inputs)
	if (locale === "de") return de_cerez_s6_note(inputs)
	if (locale === "ru") return ru_cerez_s6_note(inputs)
	return tr_cerez_s6_note(inputs)
});